/**
 * 用同一個 reactive 物件替換表單內容。
 *
 * Ant Design Vue 的 Form 在掛載時會保存 model 的參考；不可在編輯時
 * 將 model 換成另一個物件，否則欄位可能仍讀取第一次的空資料。
 */
export const replaceReactiveFormData = (target, source = {}) => {
    Object.keys(target).forEach((key) => {
        delete target[key];
    });

    Object.assign(target, source);
};
